import { observer } from "mobx-react"
import { DEFAULT_LANG, Languages } from "@providers"
import { redirect } from "@lib/isomorphic"
import {
  Page,
  Header,
  MainNavigation,
  useStore,
  Footer,
  PureLogo,
} from "@features/common"
import {
  EditorChoice,
  InstagramCarousel,
  JournalLogoEN,
  JournalLogoRU,
  JournalNavigation,
  PostsGrid,
  TikTokCarousel,
  YoutubeCarousel,
  PromoBanner,
  SocialPostClippath,
  ArticlePreviewClipPath,
} from "@features/journal"
import { scrollToTop } from "@lib/scroll"
import { RouterLink } from "@lib/routing"
import { IconHamburger } from "@lib/icons"
import { useShowSubscriptionDialog } from "@features/subscription"
import { useSmartBanner } from "@features/smart-banner"

// @ts-ignore
export async function getServerSideProps(ctx) {
  const Models = ctx.req.Models
  const { lang = "en" } = ctx.params

  if (
    Models.GlobalModel.accessLanguages.findIndex(
      (accessLang) => accessLang === lang,
    ) === -1 ||
    // @ts-ignore
    !Languages[lang]
  ) {
    if (Models.GlobalModel.accessLanguages.length > 0) {
      redirect(`/${DEFAULT_LANG}`, ctx)
    } else if (!/not-found/i.test(ctx.req.url ?? "")) {
      redirect(`/${DEFAULT_LANG}/not-found`, ctx)
    }
    return { props: Models.serialize() }
  }

  Models.GlobalModel.setLang(lang)

  // TODO: Добавить на глобальном уровне опредление девайса по req.headers['user-agent'] на стороне сервера и мерджить его с определением на стороне клиента, так как на стороне сервера, мы не знаем размеры окна. Подумать как сделать изоморфный определитель девайса и вынести его в хуки/модель.

  try {
    await Models.GlobalModel.getClientCountryCode(ctx)
    await Models.BlogModel.getInitialData()
    await Models.GlobalModel.getSmartBanner()

    return {
      props: Models.serialize(),
    }
  } catch (err) {
    return {
      redirect: {
        destination: `/${lang}/not-found`,
        permanent: false,
      },
    }
  }
}

const JournalPage = observer(function JournalPage() {
  const { GlobalModel, BlogModel } = useStore()
  const { smartBanner } = useSmartBanner()

  useShowSubscriptionDialog()

  const pageTitle = BlogModel.getTemplate("title")
  const metaTitle = BlogModel.getTemplate("metaTitle") || pageTitle
  const pageDescription = BlogModel.getTemplate("metaDescription")
  const seoH1 = BlogModel.getTemplate("seoH1.title")

  const alternateLinks = GlobalModel.accessLanguages.map((lang) => ({
    lang,
    url: `${GlobalModel.originUrl || ""}/${lang}/journal`,
  }))

  return (
    <Page
      meta={{
        title: pageTitle,
        description: pageDescription,
        metaTitle,
        alternateLinks,
      }}
      navigation={
        <MainNavigation>
          <JournalNavigation />
        </MainNavigation>
      }
      smartBanner={smartBanner}
      header={
        <Header
          theme="dark"
          logo={
            <RouterLink
              uri="/journal"
              onClick={() => scrollToTop()}
              data-test-id="header__pure_logo"
              aria-label="root"
              className="mt-4 mb-3"
            >
              <div className="flex space-x-2 tablet-m:space-x-4">
                <PureLogo className="text-white h-4 w-auto my-1 tablet:w-auto tablet-m:h-7 tablet:h-7 tablet-m:my-1.5" />
                <>
                  {GlobalModel.lang === "ru" ? (
                    <JournalLogoRU />
                  ) : (
                    <JournalLogoEN />
                  )}
                </>
              </div>
            </RouterLink>
          }
          languageSwitcher={null}
          navigationOpener={
            <button
              onClick={GlobalModel.openMenu}
              data-test-id="header__menu_button"
              aria-label="menu"
            >
              <IconHamburger className="w-8 h-8 text-white" />
            </button>
          }
        />
      }
      alternativeHeader
      footer={
        <Footer
          googlePlayLink={BlogModel.branch_links.main_footer_google_play}
          appStoreLink={BlogModel.branch_links.main_footer_app_store}
          appGalleryLink={BlogModel.branch_links.main_footer_app_gallery}
        />
      }
      seoH1={seoH1}
    >
      <div className="bg-journal-background bg-no-repeat bg-[length:100%_1628px] bg-[center_-80px]">
        <ArticlePreviewClipPath />
        <div className="pt-9 tablet:pt-12">
          <PostsGrid />
        </div>
        <div className="mt-13 mb-16 tablet:mt-12 tablet:mb-19 desktop:mb-24">
          <PromoBanner />
        </div>
        <EditorChoice />
        <InstagramCarousel />
        <TikTokCarousel />
        <YoutubeCarousel />
        <SocialPostClippath />
      </div>
    </Page>
  )
})

export default JournalPage
